import { Injectable } from '@angular/core';
import { SessionStorageService, StateService } from '../../../../../../core';
import { TipoClassificacao, Produtividade } from '../../../adapters';
import { ProdutividadeClassificacoesKPIWidgetState } from './produtividade-classificacoes-kpi-widget-state.interface';

@Injectable()
/** Service para gerenciamento do state do component de widget dos KPIs de produtividade */
export class ProdutividadeClassificacoesKPIWidgetStateService extends StateService<ProdutividadeClassificacoesKPIWidgetState> {
    constructor(sessionStorageService: SessionStorageService,) {
        super(
            sessionStorageService,
            {
                data: null,
                tipoClassificacaoAtual: null,
                periodicidade: null
            }
        );
    }

    /** Seta os dados dos KPIs */
    setData(data: Produtividade): void {
        this.state.data = data;
        this.propagateState();
    }

    /** Seta o tipo de classificação atualmente vísivel */
    setTipoClassificacaoAtual(tipoClassificacaoAtual: TipoClassificacao): void {
        this.state.tipoClassificacaoAtual = tipoClassificacaoAtual;
        this.propagateState();
    }

    /** Seta a periodicidade de visualização */
    setPeriodicidade(periodicidade: number) {
        this.state.periodicidade = periodicidade;
        this.propagateState();
    }
}
